import React from 'react';
import styled from 'styled-components';
import Avatar from '../../Avatar';
import { Paragraph } from '../../Typography';

type BrokerageInfoProps = {
  orgLogoUrl?: string;
  orgName: string;
  dataCy?: string;
};

const BrokerageInfo: React.FC<BrokerageInfoProps> = ({
  orgLogoUrl,
  orgName,
  dataCy,
}) => (
    <StyledOrg data-cy={dataCy}>
      <Avatar width={30} src={orgLogoUrl} user={{ firstName: orgName }} />
      <StyledParagraph ellipsis={{ rows: 4 }}>{orgName}</StyledParagraph>
    </StyledOrg>
  );

export default BrokerageInfo;

const StyledParagraph = styled(Paragraph)`
  && {
    margin-bottom: 0px;
  }
`;

const StyledOrg = styled.div`
  display: grid;
  grid-template-columns: 35px auto;
  gap: 5px;
  margin-bottom: 4px;
  align-items: center;
  span {
    white-space: initial;
    font-size: 90%;
  }
`;
